import React, { useState, useEffect } from 'react';
import { X, Save, Truck } from 'lucide-react';
import './TransporteModal.css';

const TransporteModal = ({ transporte, onClose, onSave, mode = 'create' }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    tipo: 'nacional'
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (transporte && mode === 'edit') {
      setFormData({
        nombre: transporte.nombre || '',
        tipo: transporte.tipo || 'nacional'
      });
    }
  }, [transporte, mode]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }

    if (!formData.tipo) {
      newErrors.tipo = 'El tipo es requerido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpiar error del campo cuando el usuario empieza a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      if (mode === 'edit') {
        await onSave(transporte.id, formData);
      } else {
        await onSave(formData);
      }
      onClose();
    } catch (error) {
      console.error('Error saving transporte:', error);
      setErrors({ submit: 'Error al guardar el transporte' });
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content transporte-modal">
        {/* Header */}
        <div className="modal-header">
          <div>
            <h2 className="modal-title">
              <Truck size={24} />
              {mode === 'edit' ? 'Editar Transporte' : 'Nuevo Transporte'}
            </h2>
            <p className="modal-subtitle">
              {mode === 'edit' 
                ? 'Modifica la información del transporte' 
                : 'Ingresa los datos del nuevo transporte'}
            </p>
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {/* Nombre */}
            <div className="form-group">
              <label className="form-label">
                Nombre del Transporte <span className="required">*</span>
              </label>
              <input
                type="text"
                name="nombre"
                className={`form-input ${errors.nombre ? 'error' : ''}`}
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Ej: Turbus, ARMELLINI, etc."
                autoFocus
              />
              {errors.nombre && (
                <span className="error-message">{errors.nombre}</span>
              )}
            </div>

            {/* Tipo */}
            <div className="form-group">
              <label className="form-label">
                Tipo <span className="required">*</span>
              </label>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="tipo"
                    value="nacional"
                    checked={formData.tipo === 'nacional'}
                    onChange={handleChange}
                  />
                  <span className="radio-text">
                    <strong>Nacional</strong>
                    <small>Para clientes en Chile</small>
                  </span>
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="tipo"
                    value="exportacion"
                    checked={formData.tipo === 'exportacion'}
                    onChange={handleChange}
                  />
                  <span className="radio-text">
                    <strong>Exportación</strong>
                    <small>Para clientes en USA/Canadá</small>
                  </span>
                </label>
              </div>
              {errors.tipo && (
                <span className="error-message">{errors.tipo}</span>
              )}
            </div>

            {/* Error general */}
            {errors.submit && (
              <div className="alert alert-error">
                {errors.submit}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              <Save size={18} />
              {loading 
                ? (mode === 'edit' ? 'Actualizando...' : 'Creando...') 
                : (mode === 'edit' ? 'Actualizar' : 'Crear')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TransporteModal;
